// Pure helpers for the shortlister FilterNav selects, kept out of the component so they can be unit tested.

const hasOwn = (object, key) => Object.prototype.hasOwnProperty.call(object, key)

// The Country select emits country codes (keys of FilterNavFields' textMap). Values restored from a saved query
// arrive as country names, and the cities API expects names. A name that is already supported maps to itself.
// Any other value (for example "Not sure", "Europe" or null) is dropped with a warning, because the cities API
// rejects null and blank entries with a 400.
export const toSupportedCountryNames = (values, countryNameByCode) => {
	const supportedNames = new Set(Object.values(countryNameByCode))
	return values.reduce((names, value) => {
		if (hasOwn(countryNameByCode, value)) return [...names, countryNameByCode[value]]
		if (supportedNames.has(value)) return [...names, value]
		console.warn('Dropping unsupported country filter value', value)
		return names
	}, [])
}
